import { Menu } from '@headlessui/react'

import { useIsMounted } from '../../../hooks'
import { TransitionRight } from '../../Animation'
import { Close, HitOutLineMenu } from '../../Icons'
import NavLink from '../NavLink'

/**
 * @return {JSX.Element} Mobile Navigation Bar
 */
export default function MobileMenu({
  navlinks,
}: {
  navlinks: {
    title: string
    href: string
  }[]
}) {
  const isMounted = useIsMounted()

  return (
    <Menu as="header" className="absolute lg:hidden landscape:hidden">
      <Menu.Button className="z-[3] w-10 inline-flex px-1 py-1   mx-1 -my-2 justify-center text-sm transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white ring-transparent focus-visible:ring-opacity-75">
        <HitOutLineMenu />
      </Menu.Button>
      {isMounted && (
        <TransitionRight>
          <Menu.Items
            as="div"
            className="z-10 fixed grid top-0 items-center text-sm left-0 mt-0 min-h-[100vh] min-w-[50vw] max-w-[70vw] origin-top-right shadow-lg ring-1 ring-transparent text-secondary ease-in-out  duration-500 ring-opacity-5 focus:outline-none"
          >
            <Menu.Item as="div" className="absolute top-0 right-0 z-10 mx-2 my-2 ">
              <Menu.Button as="button" className="flex items-center justify-center w-10 h-10">
                <Close />
              </Menu.Button>
            </Menu.Item>
            <div className="z-20 grid w-full grid-flow-row p-4">
              {navlinks.map(({ title, href }) => (
                <Menu.Item key={'PopoverPanel<>' + title + href} as="div">
                  <NavLink
                    className="relative flex px-10 py-2 text-left cursor-pointer text-primary hover:text-green-500 focus:text-green-500"
                    href={href}
                  >
                    <Menu.Button>{title}</Menu.Button>
                  </NavLink>
                </Menu.Item>
              ))}
            </div>
            <div className="rounded-r-lg custom-backdrop-blur" />
          </Menu.Items>
        </TransitionRight>
      )}
    </Menu>
  )
}
